import { getCategoryGender } from "../../state/modules/category";
import { FLOOR_MEN, FLOOR_WOMEN } from "../../state/modules/config/constants";

const floorSelector = state =>
  getCategoryGender(state) === "men" ? FLOOR_MEN : FLOOR_WOMEN;

export default floorSelector;
